/**
 * sessionStorage key for the deep-linked path a user was trying to reach
 * before AuthGuard sent them to /login. The Zitadel OIDC round-trip always
 * returns to a fixed redirect_uri (ZITADEL_REDIRECT_URI, always /login), so
 * this is the only way to carry the original destination across the
 * full-page redirect to Zitadel and back.
 */
export const POST_LOGIN_RETURN_URL_KEY = 'postLoginReturnUrl';

/**
 * sessionStorage key for the *absolute* return address carried in
 * `/login?next=`, stashed the moment the login page is entered.
 *
 * A separate key from the one above because the two hold different shapes and
 * are validated differently: this one is an absolute URL checked against this
 * environment's two origins, that one is a same-app relative path.
 *
 * It exists because `?next=` cannot survive the sign-in itself. `silentAuth`
 * sends the browser to Zitadel from the login page's own ngOnInit, and Zitadel
 * comes back to the fixed, query-less ZITADEL_REDIRECT_URI -- so by the time a
 * login succeeds the address bar reads `/login?code=...&state=...` and `next`
 * is gone. Stashing it on entry keeps it: the write and the read both happen on
 * the estimator origin, which is the one origin the whole round trip stays on.
 *
 * Stashed is not trusted. The value is re-checked against the origin allowlist
 * when it is read, not only when it is written.
 */
export const POST_LOGIN_NEXT_URL_KEY = 'postLoginNextUrl';
